export const orderSuccess = [
    { columns: [{ span: 24, height: "240px" }], classes: "marginTop-8 flex justifyCenter" },
    {
        columns: [{ span: 8, height: "170px", classes: "marginTop-16 marginBottom-24" }],
        classes: "flex justifyCenter",
    },
    {
        columns: [
            { span: 9, height: "300px" },
            { span: 9, height: "600px" },
        ],
        classes: "flex justifyEvenly marginTop-16 marginBottom-24",
    },
]
